import React from 'react';
import { useTranslation } from 'react-i18next';
const Desc = () => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: 'desc-menu' }, t('menuController.desc')));
};
export default Desc;
